"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.setIsConnected = function (isConnected) {
    return toolkit_1.createAction(constants_1.SET_AIRPLAY_CONNECTED)(isConnected);
};
exports.setIsAvailable = function (isAvailable) {
    return toolkit_1.createAction(constants_1.SET_AIRPLAY_AVAILABLE)(isAvailable);
};
//# sourceMappingURL=actions.js.map